import { HttpClient } from '@brunommsilva/react-foundations';

import appConfig from '../../config/app-config';

export type AuthTokens = {
  accessToken: string;
  refreshToken: string;
};

/**
 * Much longer than the one of the other requests: a refresh that the app gives up on has already been done by
 * the server, which has swapped the refresh token for a new one that the app never gets, and the old one stops
 * working. Right after a deploy the server is slow to answer.
 */
const AUTH_TIMEOUT_MS = 8000;

class AuthApi extends HttpClient<unknown> {
  constructor() {
    super(`${appConfig.getApiBaseURL()}/auth`, {
      timeoutMs: AUTH_TIMEOUT_MS,
    });
  }

  public login = async (
    username: string,
    password: string
  ): Promise<AuthTokens> => {
    return this.httpPost<{ username: string; password: string }, AuthTokens>(
      `${this.baseUrl}/login`,
      { username, password }
    );
  };

  public logout = async (refreshToken: string): Promise<void> => {
    return this.httpPost<{ refreshToken: string }, void>(
      `${this.baseUrl}/logout`,
      { refreshToken }
    );
  };

  public refresh = async (refreshToken: string): Promise<AuthTokens> => {
    return this.httpPost<{ refreshToken: string }, AuthTokens>(
      `${this.baseUrl}/refresh`,
      { refreshToken }
    );
  };
}

export const authApi = new AuthApi();
